import { useState, useEffect } from "react";
import Camp from "../Camp/Camp";
import CTA from "../CTA/CTA";
import s from "./Main.module.scss";


const Main = () => {
    const [isDonVisible, setIsDonVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const scrollThreshold = window.innerHeight * 0.20;

            if (scrollPosition > scrollThreshold) {
                setIsDonVisible(true);
            } else {
                setIsDonVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    return (
        <main>
            {isDonVisible && (
                <section className={s.donMobile}>
                    <CTA />
                </section>
            )}
            <section className={s.banner} id="top">
                <h1>Découvrez nos engagements</h1>
                <p>L'association Valentin Haüy se mobilise tous les jours afin de faire respecter les droits des personnes déficientes visuelles, y compris les plus vulnérables que nous accueillons dans nos différents établissements sociaux et médico-sociaux. Découvrez nos engagements et nos plaidoyers ! </p>
            </section>
            <section className={s.lastCamp}>
                <h2>Notre dernière campagne</h2>
                <Camp 
                    url="https://sensibiliser.avh.asso.fr/rentree-litteraire/"
                    size="large"
                    image="/assets/campagnes/rentreeLit.png"
                    alt=""
                    title="Rentrée littéraire"
                    description="Comme chaque année, les équipes de l’association Valentin Haüy se mobilisent pour rendre les principaux titres de la rentrée littéraire accessibles. Parce que la lecture est un droit, aidez-nous à rendre la lecture accessible à tous ! Découvrez notre action avec la rentrée littéraire pour tous. "
                    backgroundColor="#FD6834"
                />
            </section>
            <section className={s.allCamp} id="campagnes">
                <h2>Toutes nos campagnes</h2>
                <div className={s.gridCamp}>
                    <div className={s.row}>
                        <Camp 
                            url="https://sensibiliser.avh.asso.fr/rentree-litteraire/"
                            size="medium"
                            image="/assets/campagnes/rentreeLit.png"
                            alt=""
                            title="Rentrée littéraire"
                            description="Parce que la lecture est un droit, aidez-nous à rendre la lecture accessible à tous ! Découvrez notre action avec la rentrée littéraire pour tous. "
                            backgroundColor="#C9E6C5"
                        />
                        <Camp 
                            url="https://sensibiliser.avh.asso.fr/moyen-age-captcha/"
                            size="medium"
                            image="/assets/campagnes/moyenAgeCaptcha.png"
                            alt=""
                            title="Moyen Âge Captcha"
                            description="Parce qu'Internet pourrait être un formidable outil d’inclusion sociale et d’autonomie ! Découvrez notre action pour rendre le web accessible à tous. "
                            backgroundColor="#FD6834"
                        />
                    </div>
                    <div className={s.row}>
                        <Camp 
                            url="https://sensibiliser.avh.asso.fr/un-metier-pour-moi/"
                            size="small"
                            image="/assets/campagnes/metierMoi.png"
                            alt=""
                            title="Un métier pour moi"
                            description="Aidez-nous à rendre l’emploi accessible aux personnes aveugles ou malvoyantes : découvrez notre engagement pour l’égalité des chances !"
                            backgroundColor="#C9E6C5"
                        />
                        <Camp 
                            url="https://sensibiliser.avh.asso.fr/braille-musical/"
                            size="medium"
                            image="/assets/campagnes/brailleMusic.png"
                            alt=""
                            title="Braille musical"
                            description="L’association Valentin Haüy est l’un des derniers transcripteurs de partitions musicales en braille.  Préservez le braille musical et soutenez l'accès à la musique pour les personnes déficientes visuelles grâce à nos partitions en braille."
                            backgroundColor="#FD6834"
                        />
                        <Camp 
                            url="https://sensibiliser.avh.asso.fr/mediatheque-eole/"
                            size="small"
                            image="/assets/campagnes/mediatheque.png"
                            alt=""
                            title="Médiathèque Éole"
                            description="Aidez-nous à offrir aux personnes aveugles et malvoyantes l’accès à des milliers de livres audio et à une culture plus inclusive grâce à notre médiathèque numérique !"
                            backgroundColor="#C9E6C5"
                        />
                    </div>
                </div>
            </section>

            <section className={s.allPeti} id="petitions">
                <h2>Nos plaidoyers et pétitions</h2>
                <div className={s.gridPeti}>
                    <div className={s.row}>
                        <Camp 
                            url="https://www.avh.asso.fr/nos-solutions/accessibilite/accessibilite-numerique/plaidoyer"
                            size="medium"
                            image="/assets/petitions/plaiAccessNum.png"
                            alt=""
                            title="L'accessibilité numérique"
                            description="Soutenez notre plaidoyer pour un numérique accessible à tous et aidez à faire entendre la voix des personnes en situation de handicap !"
                            backgroundColor="#FD6834"
                        />
                        <Camp 
                            url="https://www.avh.asso.fr/nous-decouvrir/nos-engagements/la-cfpsaa-publie-son-plaidoyer-sur-lecole-inclusive"
                            size="small"
                            image="/assets/petitions/plaiEcoleInclu.png"
                            alt=""
                            title="L'école inclusive"
                            description="Soutenez notre plaidoyer pour une école inclusive et garantissez à chaque élève déficient visuel un accès égal à l’éducation !"
                            backgroundColor="#3DCEEB"
                        />
                    </div>
                    <div className={s.row}>
                        <Camp 
                            url="/plaidoyer-barriere-age/"
                            size="medium"
                            image="/assets/petitions/plaiBarAge.png"
                            alt=""
                            title="L'anniversaire de trop"
                            description="Découvrez notre plaidoyer sur le handicap visuel lié à l’âge. Rejoignez notre mouvement pour faire entendre leur voix et rendre à ces personnes le droit à une vie autonome."
                            backgroundColor="#FFCF32"
                        />
                    </div>
                </div>
            </section>
        </main>
    )
}

export default Main;